import React from "react";
import { Button, Tooltip } from "antd";
import { BiUndo } from "react-icons/bi";
import { useHistory } from "react-router-dom";
import Style from "./index.module.scss";

interface Props {
    title: string;
    tips: string | React.ReactChild;
    children?: React.ReactChild;
}
const Index = ({ title, tips, children }: Props) => {
    const history = useHistory();

    return (
        <div className={Style.root}>
            <div>
                <h1 className={Style.title}>
                    <Tooltip title={title} placement="bottom">
                        <span>{title}</span>
                    </Tooltip>

                    <Button
                        className={Style.back}
                        onClick={() => history.goBack()}>
                        <BiUndo size={16} /> 返回
                    </Button>
                </h1>

                <div className={Style.infos}>{tips}</div>
            </div>
            {children}
        </div>
    );
};

export default Index;
